import type { PaletteColorOptions } from "@mui/material";

const mainColor = "#3A93D0";

export const secondaryLight: PaletteColorOptions = {
  main: mainColor,
  light: "#6CB6E8",
  dark: "#0076C8",
  contrastText: "#fff",
};
